import { Box } from "@mui/material";
import React, { useRef, useEffect } from "react";
import { useAuthStore } from "../@shared/store/useAuthStore";

const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

export default function WebJoystick({
  size = 100,
  thumbSize = 50,
  onMove,
  onRelease,
  progress,
}) {
  const baseRef = useRef();
  const { userData } = useAuthStore();
  // const [dragging, setDragging] = useState(false);
  // const [thumbPos, setThumbPos] = useState({ x: 0, y: 0 });
  const draggingRef = useRef(false);
  const [thumbPos, setThumbPos] = React.useState({ x: 0, y: 0 });

  // Normalize coords to [-1,1]
  const maxRadius = (size - thumbSize) / 2;
  const toNorm = (dx, dy) => ({
    x: clamp(dx / maxRadius, -1, 1),
    y: clamp(dy / maxRadius, -1, 1),
  });

  const handlePointerMove = (e) => {
    // if (!dragging) return;
    if (!draggingRef.current) return;
    document.querySelector(".driver-popover-close-btn")?.click(); // Close current
    const rect = baseRef.current.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = e.clientX - cx;
    const dy = e.clientY - cy;
    const dist = Math.hypot(dx, dy);
    const angle = Math.atan2(dy, dx);
    const capped =
      dist > maxRadius
        ? { x: Math.cos(angle) * maxRadius, y: Math.sin(angle) * maxRadius }
        : { x: dx, y: dy };

    setThumbPos(capped);
    onMove?.(...Object.values(toNorm(capped.x, capped.y)));
  };

  const handlePointerUp = () => {
    document.querySelector(".driver-popover-close-btn")?.click(); // Close current
    // setDragging(false);
    draggingRef.current = false;
    setThumbPos({ x: 0, y: 0 });
    onRelease?.();
    window.removeEventListener("pointermove", handlePointerMove);
    window.removeEventListener("pointerup", handlePointerUp);
  };

  const handlePointerDown = (e) => {
    console.log("🕹 pointerdown!", e.clientX, e.clientY);
    document.querySelector(".driver-popover-close-btn")?.click(); // Close current
    e.preventDefault();
    // setDragging(true);
    draggingRef.current = true;
    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("pointerup", handlePointerUp);
  };

  return (
    <>
      {!userData.completedTutorial &&
        (progress?.currentStepIndex === 1) && (
          <Box
            onPointerDown={handlePointerDown}
            onMouseDown={handlePointerDown}
            onTouchStart={handlePointerDown}
            data-driver={
              "joystick-control"
            }
            style={{ overflow: "visible" }}
            sx={{
              position: "absolute",
              bottom: "70px",
              left: "5%",
              width: "100px",
              height: "100px",
              // transform: "skewX(50deg)",
              zIndex: 0,
              backgroundColor: "transparent",
              pointerEvents: "none",
              // outline: "2px solid red", // ✅ debugging

            }}

          />
        )}
      <div
        ref={baseRef}
        onPointerDown={handlePointerDown}
        onMouseDown={handlePointerDown}
        onTouchStart={handlePointerDown}
        style={{
          position: "absolute",
          bottom: 50,
          left: 20,
          width: size,
          height: size,
          borderRadius: "50%",
          backgroundColor: "rgba(144, 144, 144, .5)",
          boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          touchAction: "none",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            width: thumbSize,
            height: thumbSize,
            borderRadius: "50%",
            backgroundColor: "#444",
            //   border: "2px solid #000",
            transform: `translate(${thumbPos.x}px, ${thumbPos.y}px)`,
            pointerEvents: "none",
            padding: "10px",
            boxShadow: "2px 2px 15px black",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              boxShadow: "inset 0 0 15px rgba(0, 0, 0, 0.5)",
            }}
          />
        </div>
      </div>
    </>
  );
}
